import { GA } from '@/api/analytics'
import { env } from '@/api/tools'
import { loadStripe } from '@stripe/stripe-js'
import Axios from 'axios'
import firebase from 'firebase'
import { PLANS, Plans, Permissions } from '../models/Plan'

export const getPlan = (planId: keyof Plans) => {
  return PLANS[planId]
}

export const permission = (planId: keyof Plans, permissionId: keyof Permissions) => {
  const plan = getPlan(planId)
  return plan.permissions[permissionId] || false
}

/* PRODUCTION
VUE_APP_STRIPE_PRICE_ID_MONTHLY_PLUS=price_1I8pDZJGRvktQoZkof1liS4l
VUE_APP_STRIPE_PRICE_ID_MONTHLY_PRO=price_1I95aBJGRvktQoZkG2Rb3qUg

/* TEST
VUE_APP_STRIPE_PRICE_ID_MONTHLY_PLUS=price_1I97V4JGRvktQoZkQscPvTFq
VUE_APP_STRIPE_PRICE_ID_MONTHLY_PRO=price_1I97VPJGRvktQoZk8fn25fHw
*/

const priceIds: any = {
  'PLUS': {
    monthly: env('STRIPE_PRICE_ID_MONTHLY_PLUS')
  },
  'PRO': {
    monthly: env('STRIPE_PRICE_ID_MONTHLY_PRO')
  }
}

const cloudFunction = async (name: string, params?: object) => {
  const idToken = await firebase.auth().currentUser?.getIdToken(true)    
  const url = 'https://us-central1-tripply-app.cloudfunctions.net/' + name
  return Axios.get(url, {
    params: {
      idToken: idToken,
      ...params
    }
  })
}

export const continueSubscription = async () => {
  GA('plan_continue')
  await cloudFunction('continueSubscription')
  return true
}

export const subscribeToPlan = async (planId: keyof Plans) => {
  GA('plan_upgrade_intention', { planId: planId } )
  const priceId = priceIds[planId].monthly
  const checkoutSession: { data: { sessionId: string }} = await cloudFunction('createCheckoutSession', {planId: planId, priceId: priceId})
  const stripe = await loadStripe(env('STRIPE_PUBLIC_KEY'))
    
  if (stripe) {
    stripe.redirectToCheckout({
      sessionId: checkoutSession.data.sessionId
    })
  }
}

// When user arrives at /success complete the subscription
export const onPlanSubscriptionSuccess = async (sessionId: string) => {
  GA('plan_upgrade', { sessionId: sessionId } )
  return new Promise((resolve, reject) => {
    const unsubscribeAuthState = firebase.auth().onAuthStateChanged(async () => {
      const session: { data: any } = await cloudFunction('createSubscription', {sessionId: sessionId})
      unsubscribeAuthState()
      resolve(session)
    })
  })
}

export const updateSubscription = async (planId: keyof Plans) => {
  GA('plan_update', { planId: planId } )
  const priceId = planId && priceIds[planId] ? priceIds[planId].monthly : null
  await cloudFunction('updateSubscription', {planId: planId, priceId: priceId})
  return true
}

export const cancelSubscription = () => {
  GA('plan_cancel')
  return updateSubscription('FREE')
}

export const redirectTomanageSubscription = async (): Promise<void> => {
  GA('plan_manage')
  const response: { data: string } = await cloudFunction('createCustomerPortalSession')
  const url = response.data
  window.location.replace(url)
}